import { Component } from '@angular/core';

import { AccountService } from './_services';
import { Role, User } from './_models';
import { ChangePasswordComponent } from './changepassword.component';
import {  NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({ selector: 'app', templateUrl: 'app.component.html' })
export class AppComponent {
  user: User;
  role=Role;
  

  constructor(private accountService: AccountService, private modalService: NgbModal) {
    this.accountService.user.subscribe(x => this.user = x);
  }
  ngOnInit() {
    this.accountService.storageUserSessionAction();

   
  }

  openChangePasswordDialog(): void {
    //console.log("sessionstorage", localStorage.getItem('uid'));
    const modalRef = this.modalService.open(ChangePasswordComponent, {
      backdrop: 'static',
      keyboard: false,
    });

  }
  logout() {
    this.accountService.logout();
    localStorage.removeItem("userId");
    localStorage.removeItem("automationID");
  }
}
